import { createStore, useStore } from 'zustand';

import { HttpError } from 'utils/HttpError';
import { trackError } from 'utils/trackError';

const errorStore = createStore<{ error: Error | null }>(() => ({
  error: null,
}));

// Actions

export function setError(error: Error | null) {
  errorStore.setState({ error });

  if (error instanceof HttpError && error.statusCode !== 404) {
    trackError(error);
  }
}

// Hook

export function useErrorStore() {
  return useStore(errorStore);
}
